export default __webpack_public_path__ + "static/media/topic.c0613453.svg";